
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <div class="page-wrapper">

    <div class="name-img-wrapper">
      <img src="assets/img/shortcut-icon.png" class="img" />
      <div class="name">Register a New Pro</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Personal information</div>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="newPro.fullName" name="fullName" type="text" #email="ngModel" required [disabled]="disableEntry"
          placeholder="Full name">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="newPro.email" name="email" type="email" #email="ngModel" required [disabled]="disableEntry"
          placeholder="Email">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="newPro.phone" name="phone" type="text" #email="ngModel" required [disabled]="disableEntry"
          placeholder="Phone">
        </ion-input>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-select [(ngModel)]="newPro.businessLocationID" value="" placeholder="Choose a location" [interfaceOptions]="interfaceOptions('Location', 'Add new locations in Business settings.')" [disabled]="disableEntry">
          <ion-select-option *ngFor="let l of businessLocations" value="{{l.id}}">{{l.name}}, {{l.address.city}}, {{l.address.state}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item class="input-item" lines="none">
        <ion-select [(ngModel)]="newPro.businessCommissionID" value="" placeholder="Select commission tier" [interfaceOptions]="interfaceOptions('Commission', 'Add commission tiers in Business settings.')" [disabled]="disableEntry">
          <ion-select-option *ngFor="let c of commissionOptions" value="{{c.id}}">{{c.name}}: {{formatPercentage(c.commission)}}</ion-select-option>
        </ion-select>
      </ion-item>

      <div class="section-header">Invitation from {{userService.business ? userService.business.name : 'you'}}</div>

      <ion-item class="input-item" lines="none">
        <ion-input [(ngModel)]="newPro.businessNote" name="businessNote" type="text" #email="ngModel" required [disabled]="disableEntry"
          placeholder="Write a short note" maxlength="130">
        </ion-input>
      </ion-item>

      <p class="disclaimer">This provider will receive a text and email with login information. They will use the <a href="https://apps.apple.com/us/app/shortcut-pros/id1176656129">Shortcut Pros</a> app to onboard, manage pricing and configure availability. Once your Pro completes our Shortcut onboarding process, their profile will become active for bookings. Note: we will begin charges to your default card when this Pro submits their application. You may deactivate their profile anytime.</p>

      <ion-button class="SC-long-button submit-button" color="marine" (click)="submit()" type="submit" block [disabled]="disableEntry">
        Submit
      </ion-button>

      <p class="submit-status" *ngIf="submitStatus">{{submitStatus}}</p>
      <p class="error-status" *ngIf="errorStatus">{{errorStatus}}</p>

      <br><br>

    </div>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>